import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { main } from "./utils/configuration";
import { handleLoginRedirect } from "./utils/configuration/login/redirect";
import { config } from "./config";
import { store } from "./store/store";
import { attachRioAssistToStore } from "./utils/rioAssist";
import "rio-assist-widget/dist/rio-assist.js";
import "./styles/styles.css";
import "moment/locale/es";
import "moment/locale/en-gb";
import "moment/locale/pt-br";

const renderApplication = () => {
  createRoot(document.getElementById("root") as HTMLElement).render(<App />);
};

const renderPublic = () => {
  createRoot(document.getElementById("root") as HTMLElement).render(<div />);
};

if (window.location.href.startsWith(config.publicRoute as string)) {
  renderPublic();
} else if (window.location.href.startsWith(config.login.redirectUri as string)) {
  handleLoginRedirect();
} else {
  attachRioAssistToStore(store.getState);
  store.subscribe(() => attachRioAssistToStore(store.getState));
  main(renderApplication);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
